import RoomCodeDisplay from "../ui/RoomCodeDisplay";
import WaitingDots from "../ui/WaitingDots";

const LobbyScreen = ({ roomCode }) => (
  <div className="card">
    <div className="live-badge">
      <span className="live-dot"></span>
      Live Room
    </div>

    <h1>Waiting for <span className="accent">Opponent</span></h1>

    <RoomCodeDisplay code={roomCode} />

    <p style={{ textAlign: "center", color: "rgba(255,255,255,0.35)", fontSize: 14 }}>
      Waiting for player 2 <WaitingDots />
    </p>
  </div>
);

export default LobbyScreen;